// https://caniuse.com/?search=requestSubmit
// Only available in safari since Sept 12, 2022
function validateSubmitter(submitter: any, form: HTMLFormElement) {
	if (!(submitter instanceof HTMLElement)) {
		throw new TypeError("parameter 1 is not of type 'HTMLElement'");
	}
	if (
		!(
			submitter instanceof HTMLButtonElement ||
			submitter instanceof HTMLInputElement
		)
	) {
		throw new TypeError("The specified element is not a submit button");
	}
	if (submitter.type !== "submit") {
		throw new TypeError("The specified element is not a submit button");
	}
	if (submitter.form !== form) {
		throw new DOMException(
			"The specified element is not owned by this form element",
			"NotFoundError",
		);
	}
}

if (typeof HTMLFormElement.prototype.requestSubmit !== "function") {
	HTMLFormElement.prototype.requestSubmit = function (
		this: HTMLFormElement,
		submitter: HTMLElement | null,
	) {
		if (submitter) {
			validateSubmitter(submitter, this);
			submitter.click();
			return;
		}
		const button = document.createElement("button");
		button.type = "submit";
		button.hidden = true;
		this.appendChild(button);
		button.click();
		this.removeChild(button);
	};
}
